module.exports = __webpack_public_path__ + "pnskfsquadron/img/tw-slider-2.jpg?15ff269e";